import { render, staticRenderFns } from "./CreateAccountForm.vue?vue&type=template&id=736572fc&"
import script from "./CreateAccountForm.vue?vue&type=script&lang=js&"
export * from "./CreateAccountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports